import { StyleObject, combineStyles } from "@/utils/helpers"
import { Box } from "@mui/material"
import React, { FC } from "react"
import * as styles from "./styles"

export type StatProps = {
  titleEl: React.ReactNode
  content: React.ReactNode
  contentStyle?: StyleObject
  statsWrapper?: StyleObject
  statsTitleWrapper?: StyleObject
}

const View: FC<StatProps> = ({ titleEl, content, contentStyle = {}, statsTitleWrapper = {}, statsWrapper = {} }) => {
  if (!content) return <></>

  return (
    <Box sx={combineStyles(styles.statsWrapper, statsWrapper)}>
      <Box sx={combineStyles(styles.statTitleWrapper, statsTitleWrapper)} className='text-neutral-1000'>
        {titleEl}
      </Box>
      <Box sx={combineStyles(styles.statContent, contentStyle)}>{content}</Box>
    </Box>
  )
}

export default View
